import { render } from "./CircularLoader.vue?vue&type=template&id=53cfe6bd&scoped=true"
import script from "./CircularLoader.vue?vue&type=script&lang=js"
export * from "./CircularLoader.vue?vue&type=script&lang=js"

import "./CircularLoader.vue?vue&type=style&index=0&id=53cfe6bd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cfe6bd"]])

export default __exports__